import type { Location } from 'history';

import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

export const LINE_CLAMP_2_STYLES = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
} as const;

export const getRepeatCount = (sitterInfo: EnhancedPersonSitterProfile): number =>
  sitterInfo.providerProfile?.repeatClientCount ?? 0;

export const getShouldShowFavoriteButton = (
  sitterInfo: EnhancedPersonSitterProfile,
  ownProfile: boolean,
  isApproved: boolean,
  location: Location | undefined,
  isShortlistVisible: boolean
): boolean =>
  !ownProfile &&
  isApproved &&
  sitterInfo.authenticatedContext?.canFavorite !== false &&
  !!location &&
  !isShortlistVisible;
